'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeYesCheckSelector = exports.makeArrayCompareSelector = exports.makeEqualityCheckSelector = undefined;

var _createSelector = require('./createSelector');

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a selector factory whose input will be checked for equality against
 * the resulting selector that gets returned
 *
 * Example:
 *
 * const item = { id: 0 };
 * const getId = item => item.id;
 * const idCompareSelector = makeEqualityCheckSelector(getId);
 * const getIsIdZero = makeIdCompareSelector(0);
 * assert(getIsIdZero(item));
 */
var makeEqualityCheckSelector = exports.makeEqualityCheckSelector = function makeEqualityCheckSelector() {
    for (var _len = arguments.length, dependencySelectors = Array(_len), _key = 0; _key < _len; _key++) {
        dependencySelectors[_key] = arguments[_key];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (selectorInput) {
            return selectorInput === inputToCompare;
        }]));
    };
};

/**
 * Creates a selector factory whose input will checked to see if it exists
 * in the array that the returning selector returns.
 *
 * Example:
 *
 * const item = { attributes: ['green', 'little', 'shiny'] };
 * const getAttributes = item => item.attributes;
 * const attributeCheckSelector = makeArrayCompareSelector(getAttributes);
 * const getHasGreenAttribute = makeAttributeCheckSelector('green');
 * assert(getHasGreenAttribute(item));
 */
var makeArrayCompareSelector = exports.makeArrayCompareSelector = function makeArrayCompareSelector() {
    for (var _len2 = arguments.length, dependencySelectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        dependencySelectors[_key2] = arguments[_key2];
    }

    return function (inputToCompare) {
        return _createSelector2.default.apply(undefined, dependencySelectors.concat([function (arrayToCheck) {
            return arrayToCheck.indexOf(inputToCompare) > -1;
        }]));
    };
};

/**
 * Creates a selector factory that will compare the result of the selector with 'Y'.
 * For data that, instead of being stored as booleans, are stored as 'Y' or 'N'
 *
 * Example:
 *
 * const item = { available: 'Y' };
 * const getAvailable = item => item.available;
 * const getIsAvailable = makeYesCheckSelector(getAvailable);
 * assert(getIsAvailable(item));
 */
var makeYesCheckSelector = exports.makeYesCheckSelector = function makeYesCheckSelector() {
    for (var _len3 = arguments.length, dependencySelectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        dependencySelectors[_key3] = arguments[_key3];
    }

    var selectorFunc = dependencySelectors.pop();
    var selector = function selector(input) {
        var prop = selectorFunc(input);
        return prop === 'Y' || prop === true;
    };
    return dependencySelectors.length ? _createSelector2.default.apply(undefined, dependencySelectors.concat([selector])) : selector;
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/~/dibs-selectors/dist/utils/makeSelectorHelpers.js
// module id = 1474
// module chunks = 63